export const TITLE = "Greaves Electric Auto Price in India 2026 | Greaves EV Auto";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Greaves Electric Auto price in India ranges from ₹3.08 - ₹3.99 Lakh. Explore Greaves commercial vehicles, range, images, features & on-road prices.",
  },
  {
    name: "keywords",
    content:
      "Greaves electric auto, Greaves 3 wheeler, Greaves electric vehicles, Greaves three wheeler, Greaves electric auto price, Greaves commercial vehicles, Greaves EV auto, Greaves electric truck, Greaves Eltra, Greaves Epro, Greaves price in India, Greaves dealers, Greaves specifications, Greaves features, Greaves battery capacity, Greaves range, Greaves charging, Greaves EMI, Greaves financing, Greaves test drive, Greaves Electric Mobility, Greaves EV Auto",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Greaves",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Greaves",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Greaves Electric Auto Price in India 2026 | Greaves EV Auto",
  },
  {
    property: "og:description",
    content:
      "Greaves Electric Auto price in India ranges from ₹3.08 - ₹3.99 Lakh. Explore Greaves commercial vehicles, range, images, features & on-road prices.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Greaves Electric Auto price in India ranges from ₹3.08 - ₹3.99 Lakh. Explore Greaves commercial vehicles, range, images, features & on-road prices.",
  },
  {
    name: "twitter:title",
    content: "Greaves Electric Auto Price in India 2026 | Greaves EV Auto",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Greaves",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Greaves";

export const H1_HEADING = "Greaves Electric Auto";

export const BRAND_HEADER_INFO = "Greaves Electric Vehicles";

export const BRAND_DESCRIPTION = "Turno proudly presents Greaves Electric Vehicles, featuring the Eltra and Epro models. Discover the exceptional performance and sustainability of Greaves EVs designed to transform your transportation to the next level.Explore the Greaves Electric Commercial Vehicles range, offering sustainable and efficient mobility solutions for a brighter future.";

export const PRICE_LIST_HEADER = "Greaves Electric Load Gadis Price List in India 2026";

export const PRICE_LIST_DESCRIPTION = "Discover the price range of Greaves electric vehicles, delivering sustainable and cost-effective transportation solutions for various requirements.Greaves Electric Vehicles are engineered to provide reliable and eco-friendly transportation options. Below is a table showcasing the Greaves electric vehicle models along with their respective price ranges.";

export const PROMISES_HEADER = "Why Greaves Electric Vehicles from Turno?";

export const ADVANTAGES_HEADING = "Advantages of Greaves Electric Vehicles:";

export const ADVANTAGES_DESCRIPTION = "Turno, in partnership with Greaves, brings you electric vehicles that combine efficiency and sustainability. Elevate your transportation game with Greaves Electric Vehicles today.";

export const HIGHLIGHTS_HEADING = "Highlights of Greaves Electric Vehicles:";

export const HIGHLIGHTS_DESCRIPTION = "Greaves Electric Vehicles offer impressive battery life, providing efficient and eco-friendly transportation solutions. With their advanced technology and eco-conscious design, they are the perfect choice for those seeking sustainable mobility without compromising on performance or affordability.";

export const BLOG_HEADER = "Turno Blogs on Greaves 3 Wheeler";

export const ABOUT_HEADING = "About Greaves Electric Vehicles:";

export const ABOUT_DESCRIPTION = "Greaves Electric Vehicles are designed to redefine sustainable transportation with their advanced technology and eco-conscious features. These electric vehicles are a step forward in revolutionizing the landscape of electric mobility in India, offering a clean and efficient mode of transportation.";

export const MODELS_HEADER = "Greaves Electric Commercial Models & Range:";

export const MODELS_DESCRIPTION = "All of the vehicles offered by Greaves Goods Electric Vehicles are powered by lithium-ion batteries and come with a warranty. Greaves Electric EV also offers a range of charging solutions, including home chargers and public chargers. Greaves has also partnered with Exponent to provide affordable public fast charging stations. If you are looking for an affordable and efficient electric vehicle, Greaves Electric EV has a range of vehicles that are perfect for you.";

export const DEALER_HEADER = "Greaves EV Dealers Near Me:";

export const DEALER_DESCRIPTION = "Thanks to the expansion in the company's reach and popularity, Greaves is rapidly making its presence felt across India. As more people are leaning towards Greaves' high-quality mobility solutions that offer excellent value for money, Turno brings you this exceptional range of Electric Vehicles at affordable prices. If you want to purchase Greaves electric vehicles, you can always head to Turno.";

export const FAQ_HEADING = "FAQs on Greaves Electric Auto";

export const LOAN_HEADER = "Greaves 3 Wheeler loan";

export const CTA_TEXT = "Get On Road Price";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const AVAILABLE_BRANDS_TITLE = "Available Brands";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Greaves" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Greaves",
      item: VEHICLE_LINK,
    },
  ],
};